import { Component, forwardRef, OnInit } from '@angular/core';
import { ModelService } from '../../../../Services/model.service';
import { StartAction } from '../../../../Model/Dto/StartAction';
import { UserActionBaseComponent } from '../userAction-base.component';
import { Customer } from '../../../../Model/User/Customer';
import { Catalog } from '../../../../Model/Catalog/Catalog';
import { TranslateService } from '@ngx-translate/core';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { JobService } from 'app/Services/job.service';
import { LoginService } from 'app/Services/login.service';
import { Macro } from 'app/Model/ui/Macro';

@Component({
    selector: 'userAction-copyMediaFromOtherCatalog',
    templateUrl: 'userAction-copyMediaFromOtherCatalog.component.html',
    providers: [
        { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionCopyMediaFromOtherCatalogComponent) }
    ],
    standalone: false
})
export class UserActionCopyMediaFromOtherCatalogComponent extends UserActionBaseComponent implements OnInit {

  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public jobService: JobService,
    public translate: TranslateService,
    public catalogService: CatalogService
  ) {
    super(loginService, macroService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.loginService.customerService
      .getAllCustomerByUser(this.loginService.currentUser.id)
      .subscribe((customers: Customer[]) => {
        this.customers = customers;
        this.selectedCustomer = customers[0].id;
      });
  }

  _selectedCustomer: string;
  catalogs: Catalog[];
  _sourceCatalog: string = '';
  customers: Customer[];
  replacePrice: boolean = false;

  get selectedCustomer(): string {
    return this._selectedCustomer;
  }

  set selectedCustomer(value: string) {
    this._selectedCustomer = value;
    this.catalogService.getCatalogs(this._selectedCustomer).subscribe((result: Catalog[]) => {
      this.catalogs = result.filter((c) => !c.isVirtual);
    });
  }

  get sourceCatalog(): string {
    return this._sourceCatalog;
  }

  set sourceCatalog(sourceCompareCatalog: string) {
    this._sourceCatalog = sourceCompareCatalog;
  }

  public async canStartMacro() : Promise<boolean>{
    if (this.sourceCatalog == '') {
      return false;
    }
    if (this.sourceCatalog == this.catalogService.catalog.id) {
      return false;
    }

    return true;
  }

  public createParameterStringAsJsonString(): string {
    return JSON.stringify({ SourceCustomerId: this.selectedCustomer, SourceCatalogId: this.sourceCatalog});
  }
  parseParameter(parameter: string) {
    if (!parameter)
      return;
    try {
      const parsed = JSON.parse(parameter);
      this.selectedCustomer = parsed.SourceCustomerId;
      this.sourceCatalog = parsed.SourceCatalogId;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }
}
